import { css } from "lit";

export const styles = css`
  .containers {
    height: 100%;
  }

  .live-events-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .section-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    line-height: 20px;
    padding-bottom: var(--sds-size-space-800);
  }

  .upcoming-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .events-list {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .delete-confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .delete-confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }
  .confirmation-buttons {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300);
  }

  .events-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sds-size-space-400);
    margin-bottom: var(--sds-size-space-400);
  }

  .events-header .section-title {
    padding-bottom: 0;
    white-space: nowrap;
  }

  .events-filter {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    flex-wrap: wrap;
  }

  .no-active-events-banner {
    background-color: var(--sds-color-background-default-secondary);
    border-radius: 24px;
  }

  .events-filter-mobile {
    display: none;
  }

  @media (max-width: 900px) {
    .events-filter {
      display: none;
    }

    .events-filter-mobile {
      display: block;
      background: var(--sds-color-background-default-tertiary);
      color: var(--sds-color-text-default-primary);
      border: 1px solid var(--sds-color-border-default-default);
      border-radius: var(--sds-size-radius-200);
      padding: var(--sds-size-space-200) var(--sds-size-space-400);
      font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
      cursor: pointer;
    }
  }

  @media (max-width: 768px) {
    .section-title {
      font-size: var(--sds-typography-scale-03);
    }
  }

  .access-request-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 64px 24px;
    flex: 1;
  }

  .access-request-state .lock-icon,
  .access-request-state .check-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--sds-size-space-600);
    margin-bottom: var(--sds-size-space-800);
    border-radius: 50%;
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .access-request-state h2 {
    margin-top: 0;
    margin-bottom: var(--sds-size-space-600);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-05) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    line-height: 120%;
  }

  .access-request-state p {
    margin-top: 0;
    margin-bottom: var(--sds-size-space-800);
    font: var(--sds-typography-weight-light) var(--sds-typography-scale-03) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    max-width: 400px;
    line-height: 120%;
  }

  @media (max-width: 768px) {
    .access-request-state {
      padding: 48px 16px;
    }
  }
`;
